module.exports = __webpack_public_path__ + "media/header-cy.8097cb3f.mp4";